import { render, staticRenderFns } from "./View.vue?vue&type=template&id=7ed5f706&scoped=true"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"
import style0 from "./View.vue?vue&type=style&index=0&id=7ed5f706&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed5f706",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ed5f706')) {
      api.createRecord('7ed5f706', component.options)
    } else {
      api.reload('7ed5f706', component.options)
    }
    module.hot.accept("./View.vue?vue&type=template&id=7ed5f706&scoped=true", function () {
      api.rerender('7ed5f706', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/design/ui-components/goodslist/View.vue"
export default component.exports